import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Input, FormGroup, Form } from 'reactstrap';
import { FileText, File } from 'lucide-react';
import './ModalCrearUsuario.css';

const ModalGastoRendicion = ({ isOpen, onClose, onSave, tipoGasto, titulo }) => {
    const [formData, setFormData] = useState({
        fecha_gasto: '',
        lugar_gasto: '',
        detalle_gasto: '',
        proveedor: '',
        tipo_comprobante: '',
        serie_comprobante: '',
        numero_comprobante: '',
        monto_pago: 0,
        tipo_gasto: tipoGasto
    });

    useEffect(() => {
        if (isOpen) {
            setFormData({
                fecha_gasto: new Date().toISOString().split('T')[0],
                lugar_gasto: '',
                detalle_gasto: '',
                proveedor: '',
                tipo_comprobante: '',
                serie_comprobante: '',
                numero_comprobante: '',
                monto_pago: 0,
                tipo_gasto: tipoGasto
            });
        }
    }, [isOpen, tipoGasto]);

    const hasComprobantes = tipoGasto !== 4;

    const handleSave = () => {
        if (!formData.fecha_gasto || !formData.detalle_gasto || formData.monto_pago <= 0) {
            alert('Por favor complete los campos obligatorios (Fecha, Detalle y Monto mayor a 0).');
            return;
        }
        if (hasComprobantes && (!formData.proveedor || !formData.tipo_comprobante || !formData.numero_comprobante)) {
            alert('Para este tipo de gasto debe completar Proveedor, Tipo y Número de Comprobante.');
            return;
        }
        onSave(formData);
    };

    return (
        <Modal isOpen={isOpen} toggle={onClose} backdrop="static" centered>
            <ModalHeader className="modal-header">
                <div className="titulo">
                    <h1>{titulo.toUpperCase()}</h1>
                    <Button className="close-btn" onClick={onClose}>X</Button>
                </div>
            </ModalHeader>
            <div className="modal-body-footer">
                <ModalBody className="modal-body" style={{ padding: '1.5rem 2rem 0.5rem 2rem' }}>
                    <Form className="fila">
                        <fieldset className="fieldset-container">
                            <legend className="fieldset-legend text-sm font-bold" style={{ fontSize: '0.95rem' }}>
                                <FileText size={16} style={{ marginRight: '0.5rem' }} />
                                Datos del gasto
                            </legend>

                            <FormGroup className="form-group">
                                <label>Fecha <span className="text-danger">*</span>:</label>
                                <Input type="date" className="form-control small-input" value={formData.fecha_gasto} onChange={e => setFormData({...formData, fecha_gasto: e.target.value})} />
                            </FormGroup>
                            
                            <FormGroup className="form-group">
                                <label>Lugar:</label>
                                <Input type="text" className="form-control small-input" placeholder="Lugar del gasto" value={formData.lugar_gasto} onChange={e => setFormData({...formData, lugar_gasto: e.target.value})} />
                            </FormGroup>
                            
                            <FormGroup className="form-group">
                                <label>Detalle <span className="text-danger">*</span>:</label>
                                <Input type="text" className="form-control small-input" placeholder="Descripción del gasto" value={formData.detalle_gasto} onChange={e => setFormData({...formData, detalle_gasto: e.target.value})} />
                            </FormGroup>
                            
                            <FormGroup className="form-group">
                                <label>Monto (S/) <span className="text-danger">*</span>:</label>
                                <Input type="number" className="form-control small-input" step="0.01" min="0" placeholder="0.00" value={formData.monto_pago} onChange={e => setFormData({...formData, monto_pago: parseFloat(e.target.value) || 0})} />
                            </FormGroup>
                        </fieldset>

                        {hasComprobantes && (
                            <fieldset className="fieldset-container">
                                <legend className="fieldset-legend text-sm font-bold" style={{ fontSize: '0.95rem' }}>
                                    <File size={16} style={{ marginRight: '0.5rem' }} />
                                    Datos del comprobante
                                </legend>
                                <FormGroup className="form-group">
                                    <label>Proveedor <span className="text-danger">*</span>:</label>
                                    <Input type="text" className="form-control small-input" placeholder="Nombre del proveedor" value={formData.proveedor} onChange={e => setFormData({...formData, proveedor: e.target.value})} />
                                </FormGroup>
                                <FormGroup className="form-group">
                                    <label>Tipo de comprobante <span className="text-danger">*</span>:</label>
                                    <Input type="select" className="form-control small-input" value={formData.tipo_comprobante} onChange={e => setFormData({...formData, tipo_comprobante: e.target.value})}>
                                        <option value="">-- Seleccione --</option>
                                        <option value="1">BOLETA</option>
                                        <option value="2">FACTURA</option>
                                    </Input>
                                </FormGroup>
                                <FormGroup className="form-group">
                                    <label>Serie:</label>
                                    <Input type="text" className="form-control small-input" placeholder="Ej: B001" value={formData.serie_comprobante} onChange={e => setFormData({...formData, serie_comprobante: e.target.value})} />
                                </FormGroup>
                                <FormGroup className="form-group">
                                    <label>Número <span className="text-danger">*</span>:</label>
                                    <Input type="text" className="form-control small-input" placeholder="Número del comprobante" value={formData.numero_comprobante} onChange={e => setFormData({...formData, numero_comprobante: e.target.value})} />
                                </FormGroup>
                            </fieldset>
                        )}
                    </Form>
                </ModalBody>
                <ModalFooter style={{ padding: '0.5rem 2.5rem 1rem 2.5rem' }}>
                    <div className="button-container w-100 flex justify-end pr-2">
                        <Button color="primary" className="button-custom" onClick={handleSave}>Registrar</Button>
                    </div>
                </ModalFooter>
            </div>
        </Modal>
    );
};

export default ModalGastoRendicion;
